import React from 'react';
import './nav.css';
import { useNavigate, useLocation } from 'react-router-dom';

import dashboardIcon from '../../assets/dashboardicon.png';
import eventsIcon from '../../assets/eventsIcon.png';
import bookingsIcon from '../../assets/bookingsIcon.png';
import usersIcon from '../../assets/usersIcon.png';
import scheduleIcon from '../../assets/scheduleIcon.png';
import contentIcon from '../../assets/contentIcon.png';
import logoutIcon from '../../assets/logouticon.png';
import reviewsIcon from '../../assets/reviewsicon.png';

const Nav = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const isActive = (path) => location.pathname === path;

    return (
        <nav>
            <div className='navdiv'>

                <div className='navdiv1'>
                    <h6 className='navtitle'>Egypt Fashion Week</h6>
                </div>

                <div className='navdiv2'>

                    <button
                        className={`navbt ${isActive('/overview') ? 'selected' : ''}`}
                        onClick={() => navigate('/overview')}
                    >
                        <div className='navicondiv'>
                            <img src={dashboardIcon} alt="" className='navicon' />
                        </div>
                        <h6 className='navtext'>Dashboard</h6>
                    </button>

                    <button
                        className={`navbt ${isActive('/events') ? 'selected' : ''}`}
                        onClick={() => navigate('/events')}
                    >
                        <div className='navicondiv'>
                            <img src={eventsIcon} alt="" className='navicon' />
                        </div>
                        <h6 className='navtext'>Events</h6>
                    </button>

                    <button
                        className={`navbt ${isActive('/bookings') ? 'selected' : ''}`}
                        onClick={() => navigate('/bookings')}
                    >
                        <div className='navicondiv'>
                            <img src={bookingsIcon} alt="" className='navicon' />
                        </div>
                        <h6 className='navtext'>Bookings</h6>
                    </button>

                    <button
                        className={`navbt ${isActive('/users') ? 'selected' : ''}`}
                        onClick={() => navigate('/users')}
                    >
                        <div className='navicondiv'>
                            <img src={usersIcon} alt="" className='navicon' />
                        </div>
                        <h6 className='navtext'>Users</h6>
                    </button>

                    <button
                        className={`navbt ${isActive('/schedule') ? 'selected' : ''}`}
                        onClick={() => navigate('/schedule')}
                    >
                        <div className='navicondiv'>
                            <img src={scheduleIcon} alt="" className='navicon' />
                        </div>
                        <h6 className='navtext'>Schedule</h6>
                    </button>

                    <button
                        className={`navbt ${isActive('/content') ? 'selected' : ''}`}
                        onClick={() => navigate('/content')}
                    >
                        <div className='navicondiv'>
                            <img src={contentIcon} alt="" className='navicon' />
                        </div>
                        <h6 className='navtext'>Content</h6>
                    </button>

                    <button
                        className={`navbt ${isActive('/reviews') ? 'selected' : ''}`}
                        onClick={() => navigate('/reviews')}
                    >
                        <div className='navicondiv'>
                            <img src={reviewsIcon} alt="" className='navicon' />
                        </div>
                        <h6 className='navtext'>Reviews</h6>
                    </button>
                     <button
                        className={`navbt ${isActive('/access-denied') ? 'selected' : ''}`}
                        onClick={() => navigate('/access-denied')}
                    >
                        <div className='navicondiv'>
                            <img src={reviewsIcon} alt="" className='navicon' />
                        </div>
                        <h6 className='navtext'>Access Denied</h6>
                    </button>
                    <button
                        className='navbt logoutbtn'
                        onClick={() => navigate('/login')}
                    >
                        <div className='navicondiv'>
                            <img src={logoutIcon} alt="" className='navicon' />
                        </div>
                        <h6 className='navtext'>Log out</h6>
                    </button>
                   
                </div>

            </div>
        </nav>
    );
};

export default Nav;